import { getTypeInfo } from './questionFormatters';

export const getWordCount = (text) => {
  return text.trim().split(/\s+/).length;
};

export const isQuestionTooLong = (text, type) => {
  const typeInfo = getTypeInfo(type);
  const wordCount = getWordCount(text);
  return wordCount > typeInfo.max;
};

export const isQuestionComplex = (text) => {
  if (!text || text.trim().length < 5) return false;

  // Common acceptable phrases that shouldn't trigger complexity
  const acceptablePhrases = [
    'trends and insights',
    'roles and responsibilities',
    'goals and objectives',
    'developing and executing',
    'planning and implementing',
    'strategy and execution',
    'process and methodology'
  ];

  // Normalize text and remove acceptable phrases
  let normalizedText = text.toLowerCase();
  acceptablePhrases.forEach(phrase => {
    normalizedText = normalizedText.replace(phrase, '');
  });

  // Only flag obvious cases:
  // 1. Multiple direct questions (with question marks)
  const questionMarks = (text.match(/\?/g) || []).length;
  if (questionMarks > 1) return 'multipleQuestions';

  // 2. Obviously unrelated topics joined by "and"/"or"
  const hasUnrelatedTopics = /marketing.*and.*programming|technical.*and.*sales|design.*and.*finance/i.test(normalizedText);
  if (hasUnrelatedTopics) return 'unrelatedTopics';

  return false;
};

export const getQuestionComplexityTip = (text) => {
  const complexityType = isQuestionComplex(text);
  if (!complexityType) return {
    title: '',
    tip: '',
    example: ''
  };

  const tips = {
    multipleQuestions: {
      title: "Multiple Questions Combined",
      tip: "This question contains multiple separate questions. Consider asking them one at a time to get more detailed responses.",
      example: "Try splitting this into separate questions to allow the candidate to fully address each point."
    },
    unrelatedTopics: {
      title: "Mixed Topics",
      tip: "This question covers distinctly different topics. Consider focusing on one area at a time.",
      example: "Asking about one topic at a time helps candidates provide more focused and relevant responses."
    }
  };

  return tips[complexityType] || {
    title: "Complex Question",
    tip: "This question might be challenging to answer comprehensively. Consider simplifying it.",
    example: "Breaking down complex questions often leads to more detailed and useful responses."
  };
}; 